/**
 * Tri alphabétique locale-aware sur libellé affiché, avec clé secondaire déterministe.
 * BL-0110 — critères recherche U2000BasicSearch.
 */
export function u2000SortByLocalizedLabel<T>(
  items: readonly T[],
  getLabel: (item: T) => string,
  getSecondaryKey: (item: T) => string,
  locale: string,
): T[] {
  return [...items].sort((a, b) => {
    const byLabel = getLabel(a).localeCompare(getLabel(b), locale, { sensitivity: 'base' });
    return byLabel !== 0 ? byLabel : getSecondaryKey(a).localeCompare(getSecondaryKey(b), locale, { sensitivity: 'base' });
  });
}
